require('es6-promise').polyfill();
require('isomorphic-fetch');

import React from 'react';
import {render} from 'react-dom';
import configureStore from 'store/configureStore';
import Root from 'components/Root';
import Singleton from 'utils/singleton';


const globalStore = Singleton.getInstance();

const data_marts = document.getElementsByClassName('ex-data-mart');

for (let i = data_marts.length - 1; i >= 0; i--) {
  const data_mart = data_marts[i],
        store = configureStore(),
        dom_attrs = data_mart.attributes;

  let alias = dom_attrs.getNamedItem('data-store-alias');
  if (!alias) {
    const mart_id = dom_attrs.getNamedItem('data-selected-entry-point-id');
    if (mart_id)
      alias = `data_mart_${mart_id.value}`;
  } else
    alias = alias.value;
  globalStore[alias] = store;

  render(
      <Root store={store} dom_attrs={dom_attrs} />,
      data_mart
  );
}

// enable hot module reloading for the dev server
process.env.NODE_ENV === 'development' && module.hot.accept();
